// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2KRFM","sendOtp":"AuthorizeToLogin_sendOtp__3vZ2c"};